<template>
	<div class="o-container o-container--thin">
		<reset-new-password-form
			:submit="createPassword"
			:cancel="cancelCreatePassword"
			:sendAgain="goToResetPassword"
			:email="email"
			:code="code"
		/>
	</div>
</template>

<script>
    import ResetNewPasswordForm from '../forms/ResetNewPasswordForm.vue';
    import isEmail from '../../helpers/isEmail';
    import '../../store/modules/session/session';

	export default {
		components: {
            ResetNewPasswordForm
		},
		data() {
			return {
				form: 'verify',
				data: {
					email: this.$session.has('email') ? this.$session.get('email') : '',
					code: this.$session.has('code') ? this.$session.get('code') : ''
				},
                email: this.$session.has('email') ? this.$session.get('email') : '',
                code: this.$session.has('code') ? this.$session.get('code') : ''
			};
		},
		methods: {
			createPassword(formData) {
				return this.$store.dispatch('user/CREATE_NEW_PASSWORD', {
					email: formData.email.toLowerCase(),
					code: formData.code,
                    newPassword: formData.newPassword
				}).then(() => {
					this.$router.push({
						name: 'login',
						params: {
							message: {
								type: 'success',
								value: 'Your new password has been successfully reset and can now be used.'
							}
						}
					});
				});
			},
			cancelCreatePassword() {
				this.$router.push({
					name: 'login'
				});
			},
			goToResetPassword() {
				this.$router.push({
					name: 'resetPassword'
				});
			}
		}

	};
</script>
